import { withStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircleOutline';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';
import Button from '@material-ui/core/Button';

const styles = Object.assign({}, globalStyles);

class CreateButton extends React.Component {

    render() {

        const { classes, label, onClick, disabled, dataTest, includeIcon } = this.props;

        return (
            <Button
                data-test={dataTest}
                disabled={disabled}
                variant="contained"
                color="secondary"
                className={includeIcon ? classes.button : classes.secondaryButton}
                onClick={onClick}
                endIcon={includeIcon ? <AddCircleIcon /> : null}>
                {label}
            </Button>
        );
    }
}

CreateButton.defaultProps = {
    disabled: false,
    dataTest: "create",
    includeIcon: true
};

CreateButton.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    includeIcon: PropTypes.bool,
    label: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(CreateButton);